import { MessageCircle } from "lucide-react";
import { waLink, WA_MESSAGES } from "@/lib/site";

export const WhatsAppButton = () => (
  <a
    href={waLink(WA_MESSAGES.default)}
    target="_blank"
    rel="noopener noreferrer"
    data-testid="whatsapp-floating-btn"
    aria-label="Falar no WhatsApp"
    className="fixed bottom-6 right-6 z-50 hidden h-14 w-14 items-center justify-center rounded-full bg-[#25D366] text-white shadow-hover transition-transform hover:scale-110 animate-pulse-ring sm:flex"
  >
    <MessageCircle size={28} />
  </a>
);
